require('../filter-editor-modal.component.scss');
require('./stamprecognition-filter-editor.component.scss')

export class stamprecognitionFilterEditorController {

  constructor($scope, $http, CurrentModelService, FileUploader, FiltersService, FilterResource) {
    this.$scope = $scope;
    this.$http = $http;
    this.FileUploader = FileUploader;
    this.CurrentModelService = CurrentModelService;
    this.FiltersService = FiltersService;
    this.FilterResource = FilterResource;
    var uploader = this.uploader = this.$scope.uploader = new FileUploader({});
    
    // FILTERS
    uploader.filters.push({
        name: 'imageFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
        }
    });
    
  }

  $onInit() {

    var scope = this.$scope;
    var staffcop_filter = this.$scope.filter = this.filter.filter;
    var FiltersService = this.FiltersService;
    var uploader = this.uploader;
    uploader.url = '/analytics/upload_stamp_targets/' + this.filter.filter.id;
    var FileUploader = this.FileUploader;
    var update_target_list = function() {
        var target_list = '';
        uploader.queue.forEach((fileItem) => {
            target_list += '\n' + fileItem.file.name;
        });
//         scope.filter._changed = true;
//         scope.filter.isChanged = true;
//         console.log(scope.filter);
        scope.filter.stamp_target_files = target_list;
    };
    
    uploader.remove = function(item) {
        item.remove();
        update_target_list();
    };
    
    uploader.onErrorItem = function(fileItem, response, status, headers) {
//         console.info('onErrorItem', fileItem, response, status, headers);
        alert(gettext('Ошибка ') + status);
    };
    
    uploader.onCompleteItem = function(fileItem, response, status, headers) {
//         console.info('onCompleteItem', fileItem, response, status, headers);
        if (response.existence != undefined && response.existence.includes('check_api_conection')) {
            fileItem._onTimeout();
            alert(gettext('Пожалуйста, проверьте подключение к API модуля контентного анализа!'));
        } else if (response.existence != undefined && response.existence.includes('no_stamp_detected')) {
            fileItem._onTimeout();
            alert(gettext('Печати не обнаружены на изображении!'));
        } else {
            update_target_list();
        };
    };
    
    var target_list = this.filter.filter.stamp_target_files;
    if (target_list != undefined ) {
    var uploaded_targets = target_list.trim().split('\n').filter(i => (i));
    uploaded_targets.forEach((target) => {
        var url = '/media/stamp_targets/' + this.filter.filter.id + '/'+ target;
        var file_name = target.split('/').pop();
        this.$http.get(url, { responseType: "blob" }).then(function({data}) {
            var mimetype = data.type;
            var file = new File([data], target, {type: mimetype});
            var dummy = new FileUploader.FileItem(uploader, {
                lastModifiedDate: new Date(),
                size: data.size,
                type: mimetype,
                name: file_name
            });
            dummy._file = file;
            dummy.progress = 100;
            dummy.isUploaded = true;
            dummy.isSuccess = true;
            uploader.queue.push(dummy);
        });
    });
    }

  }
  
    uploadItem(fileItem) {
        var uploader = this.uploader;
        var scope = this.$scope;
        var filters = this.FiltersService.filters;
        if (!this.filter.filter.id) {
            this.FilterResource.save(this.filter.filter).then(({status, data, error}) => {
                if (status===200) {
//                     filters.push(scope.filter);
                    fileItem.url = uploader.url = '/analytics/upload_stamp_targets/' + data.id;
                    fileItem.upload();
                } else {
                    alert('Error saving filter: '+status);
                    console.log(data);
                }
            });
        } else {
            fileItem.upload();
        };
    };

  get filterText(){
    return JSON.stringify(this.filter, undefined, 2);
  }
  
}

class ngThumbComponent {
    constructor($window) {
        
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function(item) {
                return angular.isObject(item) && item instanceof $window.File;
            },
            isImage: function(file) {
                var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            template: '<canvas/>',
            link: function(scope, element, attributes) {
                if (!helper.support) return;

                var params = scope.$eval(attributes.ngThumb);

                if (!helper.isFile(params.file)) return;
                if (!helper.isImage(params.file)) return;

                var canvas = element.find('canvas');
                var reader = new FileReader();

                reader.onload = onLoadFile;
                reader.readAsDataURL(params.file);

                function onLoadFile(event) {
                    var img = new Image();
                    img.onload = onLoadImage;
                    img.src = event.target.result;
                }

                function onLoadImage() {
                    var width = params.width || this.width / this.height * params.height;
                    var height = params.height || this.height / this.width * params.width;
                    canvas.attr({ width: width, height: height });
                    canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                }
            }
        };
    }
    
    static directiveFactory($window) {
        ngThumbComponent.instance = new ngThumbComponent($window);
        return ngThumbComponent.instance;
    }
}

ngThumbComponent.directiveFactory.$inject = ['$window'];

export const StamprecognitionFilterEditorComponent = {
  bindings: {
    filter    : '<',
  },
  template: require('./stamprecognition-filter-editor.component.html'),
  controller: stamprecognitionFilterEditorController,
};

export { ngThumbComponent }



// WEBPACK FOOTER //
// ./src/filter/editor/spec-forms/stamprecognition-filter-editor.component.js